import CanShow from "./CanShow";
import AdsPopup from "@/features/website/AdsPopup/Index";
import WebsitePages from "@/features/website/Pages/Index";
import EditWebsitePages from "@/features/website/Pages/Edit";
import OurPartners from "@/features/website/OurPartners/Index";
import WebsiteCarousel from "@/features/website/Carousel/pages/page";
import CreateWebsitePages from "@/features/website/Pages/Create";
import FastDonation from "@/features/website/Fast-donation/Index";
import HomePageBanner from "@/features/website/HomePageBanner/Index";
import OrderHomeSection from "@/features/website/OrderHomeSection/Index";
import PrivacyPolicy from "@/features/website/Pages/PrivacyPolicy.jsx";
import TermsConditions from "@/features/website/Pages/TermsConditions.jsx";
import Themes from "@/features/website/themes/pages/page";
import ThemeForm from "@/features/website/themes/pages/form/page";
import LandingPages from "@/features/website/landing-pages/pages/page";
import LandingPageForm from "@/features/website/landing-pages/pages/form/page";

export const websiteRoutes = [
  {
    path: "/website/carousel",
    element: <CanShow page={<WebsiteCarousel />} ifHas={["editMainBanner"]} />,
  },
  {
    path: "/website/pages",
    element: (
      <CanShow
        page={<WebsitePages />}
        ifHas={["viewSitePages", "editSitePages"]}
      />
    ),
  },
  {
    path: "/website/fast-donation",
    element: (
      <CanShow
        page={<FastDonation />}
        ifHas={["viewSitePages", "editSitePages"]}
      />
    ),
  },
  {
    path: "/website/pages/create",
    element: (
      <CanShow page={<CreateWebsitePages />} ifHas={["editSitePages"]} />
    ),
  },
  {
    path: "/website/pages/:id/edit",
    element: <CanShow page={<EditWebsitePages />} ifHas={["editSitePages"]} />,
  },
  {
    path: "/website/pages/privacy-policy",
    element: <CanShow page={<PrivacyPolicy />} ifHas={["editSitePages"]} />,
  },
  {
    path: "/website/pages/terms-conditions",
    element: <CanShow page={<TermsConditions />} ifHas={["editSitePages"]} />,
  },
  {
    path: "/website/home-page-banner",
    element: <CanShow page={<HomePageBanner />} ifHas={["homepageSettings"]} />,
  },
  {
    path: "/website/order-home-section",
    element: (
      <CanShow page={<OrderHomeSection />} ifHas={["arrangeHomepageItems"]} />
    ),
  },
  {
    path: "/website/our-partners",
    element: <CanShow page={<OurPartners />} ifHas={["ourPartners"]} />,
  },
  {
    path: "/website/ads-popup",
    element: <CanShow page={<AdsPopup />} ifHas={["popups"]} />,
  },
  {
    path: "/website/themes",
    element: (
      <CanShow
        page={<Themes />}
        ifHas={["viewThemes", "editThemes", "publishThemes"]}
      />
    ),
  },
  {
    path: "/website/themes/create",
    element: <CanShow page={<ThemeForm />} ifHas={["editThemes"]} />,
  },
  {
    path: "/website/themes/:edit/edit",
    element: <CanShow page={<ThemeForm />} ifHas={["editThemes"]} />,
  },
  {
    path: "/website/themes/:show",
    element: (
      <CanShow page={<ThemeForm />} ifHas={["viewThemes", "editThemes"]} />
    ),
  },
  {
    path: "/website/landing-pages",
    element: <CanShow page={<LandingPages />} ifHas={["viewSitePages", "editSitePages"]} />,
  },
  {
    path: "/website/landing-pages/create",
    element: <CanShow page={<LandingPageForm />} ifHas={["viewSitePages", "editSitePages"]} />,
  },
  {
    path: "/website/landing-pages/:edit/edit",
    element: <CanShow page={<LandingPageForm />} ifHas={["viewSitePages", "editSitePages"]} />,
  },
  {
    path: "/website/landing-pages/:show",
    element: <CanShow page={<LandingPageForm />} ifHas={["viewSitePages", "editSitePages"]} />,
  },
];
